(function () {
  if (window.umDiaPhotoModalReady) return;
  window.umDiaPhotoModalReady = true;
  var triggers = new WeakMap();
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-photo-expand]');
    if (button) {
      var section = button.closest('.ud-photography');
      var modal = section && section.querySelector('[data-photo-modal]');
      if (!modal) return;
      var img = modal.querySelector('[data-photo-modal-image]');
      img.src = button.dataset.photoSrc;
      img.alt = button.dataset.photoAlt || '';
      modal.querySelector('[data-photo-modal-caption]').textContent = [button.dataset.photoTitle, button.dataset.photoCaption].filter(Boolean).join(' · ');
      triggers.set(modal, button);
      if (!modal.open) modal.showModal();
      return;
    }
    var close = event.target.closest('[data-photo-close]');
    if (close) { close.closest('[data-photo-modal]').close(); return; }
    if (event.target.matches('[data-photo-modal]')) event.target.close();
  });
  document.addEventListener('close', function (event) {
    var modal = event.target;
    if (!modal.matches('[data-photo-modal]')) return;
    modal.querySelector('[data-photo-modal-image]').removeAttribute('src');
    modal.querySelector('[data-photo-modal-caption]').textContent = '';
    var trigger = triggers.get(modal);
    if (trigger && trigger.isConnected) trigger.focus({preventScroll: true});
    triggers.delete(modal);
  }, true);
  document.addEventListener('shopify:section:unload', function (event) {
    var modal = event.target.querySelector('[data-photo-modal]');
    if (modal && modal.open) modal.close();
  });
})();
